import {
  CloseOutlined,
  DownOutlined,
  HomeOutlined,
  ReloadOutlined,
  VerticalLeftOutlined,
  VerticalRightOutlined,
} from '@ant-design/icons';
import { useToken } from '@ant-design/pro-components';
import { useLocation } from '@umijs/max';
import { Button, Dropdown, Space, Tabs } from 'antd';
import React from 'react';

declare type LayoutTabsProps = {
  isKeep?: any;
  keepElements?: any;
  navigate?: any;
  dropByCacheKey?: any;
  dropLeftTabs?: any;
  dropRightTabs?: any;
  dropOtherTabs?: any;
  refreshTab?: any;
  local?: any;
  activeKey?: any;
};

const LayoutTabs: React.FC<LayoutTabsProps> = (props) => {
  const {
    isKeep,
    keepElements,
    navigate,
    dropByCacheKey,
    dropLeftTabs,
    dropRightTabs,
    dropOtherTabs,
    refreshTab,
    local,
    activeKey,
  } = props;

  const location = useLocation();
  const { token } = useToken();

  const items: any = [
    {
      label: '关闭左侧',
      icon: <VerticalRightOutlined />,
      key: 'left',
    },
    {
      label: '关闭右侧',
      icon: <VerticalLeftOutlined />,
      key: 'right',
    },
    {
      label: '关闭其它',
      icon: <CloseOutlined />,
      key: 'others',
    },
  ];

  const selectAction = React.useCallback(
    ({ key }) => {
      switch (key) {
        case 'left':
          dropLeftTabs(location.pathname);
          break;

        case 'right':
          dropRightTabs(location.pathname);
          break;

        case 'others':
          dropOtherTabs(location.pathname);
          break;

        case 'refresh':
          refreshTab(location.pathname);
          break;

        default:
          break;
      }
    },
    [location.pathname],
  );

  const handleRefresh = () => {
    refreshTab(location.pathname);
  };

  const openIndex = () => {
    navigate('/home');
  };

  return (
    <>
      <div className="rumtime-keep-alive-tabs-layout" hidden={!isKeep}>
        <Tabs
          type="editable-card"
          hideAdd
          animated={false}
          activeKey={activeKey}
          tabBarExtraContent={
            <Space style={{ marginRight: 16 }}>
              <Button
                type="text"
                size="small"
                icon={<ReloadOutlined style={{ color: token.colorTextTertiary }} />}
                onClick={handleRefresh}
                title="刷新"
              />
              <Button
                type="text"
                size="small"
                icon={<HomeOutlined style={{ color: token.colorTextTertiary }} />}
                onClick={openIndex}
                title="工作台"
              />
              <Dropdown menu={{ items, onClick: selectAction }} trigger={['click']}>
                <Button
                  type="text"
                  size="small"
                  icon={<DownOutlined style={{ color: token.colorTextTertiary }} />}
                />
              </Dropdown>
            </Space>
          }
          onChange={(key: string) => {
            navigate(key);
          }}
          onEdit={(targetKey: any) => {
            const pathList = Object.entries(keepElements.current).map(([_, element]: any) => {
              return element?.location?.pathname;
            });
            if (pathList.length === 1) {
              return;
            }
            dropByCacheKey(targetKey);
            if (targetKey === activeKey) {
              const i = pathList.indexOf(targetKey);
              if (pathList[i === 0 ? i + 1 : i - 1]) {
                navigate(pathList[i === 0 ? i + 1 : i - 1]);
              }
            }
          }}
          items={Object.entries(keepElements.current).map(([_, element]: any) => {
            const pathname = element?.location?.pathname;
            let localeId = `menu${pathname}`.split('/').join('.');
            if (pathname.indexOf('/cms/article/detail') > -1) {
              localeId = 'menu.cms.article.detail.:type.:id';
            }
            if (pathname.indexOf('/mp/marketpriceqp/') > -1) {
              localeId = 'menu.mp.marketpriceqp.:id';
            }
            if (pathname.indexOf('/mp/marketpricemp/') > -1) {
              localeId = 'menu.mp.marketpricemp.:id';
            }
            if (pathname.indexOf('/mp/marketpricema/') > -1) {
              localeId = 'menu.mp.marketpricema.:id';
            }
            const pathList = Object.keys(keepElements.current);
            return {
              key: pathname,
              label: local[pathname] || pathname,
              closable: pathList.length > 1,
            };
          })}
        />
      </div>
    </>
  );
};

export default LayoutTabs;
